import $store from '../store/index'
import axios from 'axios'
import * as common from '../api/common'
import * as constant from '../api/constant'
import * as api from '../api/api'

export const isValidPhoneNumber = (phoneNumber) => {
  // 定义中国大陆手机号的正则表达式
  var pattern = /^1\d{10}$/

  // 使用正则表达式测试手机号是否匹配
  return pattern.test(phoneNumber)
}

// 点击菜单或者页面时 判断是否授权登录
export const isHaveAuthAccount = () => {
  const authState = $store.state.wxZfbAuthInfo
  return authState && authState.wxZfbAuthInfo !== undefined && authState.wxZfbAuthInfo !== null
}
// 点击菜单或者页面时 判断是否绑定手机号
export const isHaveBindPhone = () => {
  const phone = $store.state.phone ? $store.state.phone.phone : null
  if (!phone) {
    return false
  }
  return true
}

export const judgeEndDateLong = (str) => {
  if (str.substring(0, 4) >= constant.endDateFlag) {
    return true
  } else {
    return false
  }
}
export const judgeStartDateLong = (str) => {
  if (str.substring(0, 4) <= constant.startDateFlag) {
    return true
  } else {
    return false
  }
}



// 判断需不需要进行JSON解析
export const parseIfJSONString = (obj) => {
  try {
    // 尝试解析为 JSON 数组
    const parsed = JSON.parse(obj)
    // 如果成功解析，则返回解析后的数组
    if (Array.isArray(parsed)) {
      return parsed
    }
  } catch (error) {
    // 如果解析失败，返回原始值
    return obj
  }
  // 如果不是 JSON 字符串，则返回原始值
  return obj
}


/**
 * 判断广告配置是否需要关闭
 * @param sid 车场ID
 * @param getType 是否调用接口获取，1为从接口获取，2为本地缓存获取
 * @param adType 广告类型，1为非支付页面广告；2为支付页面广告，包含首页
 */
export const judgeADClose = (adConfig, getType, adType) => {
  let startTime, endTime
  if (getType === 1) {
    // 首页需要保存
    if (adConfig == null) {
      localStorage.setItem('adConfig', '{}')
    } else {
      localStorage.setItem('adConfig', JSON.stringify(adConfig))
    }
  } else {
    const firstConfig = localStorage.getItem('adConfig')
    if (firstConfig) {
      adConfig = JSON.parse(firstConfig)
    }
    if (!adConfig) {
      adConfig = {}
    }
  }
  if (adType === 1) {
    if (adConfig.ad_other_page && adConfig.ad_other_page.start_time) {
      startTime = adConfig.ad_other_page.start_time
    }
    if (adConfig.ad_other_page && adConfig.ad_other_page.end_time) {
      endTime = adConfig.ad_other_page.end_time
    }
  } else {
    if (adConfig.ad_pay_page && adConfig.ad_pay_page.start_time) {
      startTime = adConfig.ad_pay_page.start_time
    }
    if (adConfig.ad_pay_page && adConfig.ad_pay_page.end_time) {
      endTime = adConfig.ad_pay_page.end_time
    }
  }

  const now = new Date()
  if (!startTime || !endTime) {
    return false
  }
  if (now >= formatDate(startTime) && now <= formatDate(endTime)) {
    return true
  } else {
    return false
  }
}

/**
 * 判断场内付弹窗广告和通道付弹窗广告配置是否需要关闭
 * @param {Object} adConfig 广告配置对象
 * @param {Number} getType 是否调用接口获取，1为从接口获取，2为本地缓存获取
 * @param {Number} adType 广告类型：1为车牌页面（场内付）弹窗广告（对应license_plate_popup_ad_closed），2为付款页（通道付）弹窗广告（对应payment_page_popup_ad_closed）
 * @returns {Boolean} 返回true表示在时间范围内需要关闭广告，返回false表示不在时间范围内或配置无效
 */
export const judgeADClosePopup = (adConfig, getType, adType) => {
  let startTime, endTime
  if (getType === 1) {
    // 首页需要保存
    if (adConfig == null) {
      localStorage.setItem('adConfig', '{}')
    } else {
      localStorage.setItem('adConfig', JSON.stringify(adConfig))
    }
  } else {
    const firstConfig = localStorage.getItem('adConfig')
    if (firstConfig) {
      adConfig = JSON.parse(firstConfig)
    }
    if (!adConfig) {
      adConfig = {}
    }
  }

  // 根据广告类型选择对应的弹窗关闭配置字段
  let popupKey = null
  if (adType === 1) {
    // 车牌页面（场内付）弹窗广告
    popupKey = 'license_plate_popup_ad_closed'
  } else if (adType === 2) {
    // 付款页（通道付）弹窗广告
    popupKey = 'payment_page_popup_ad_closed'
  }

  if (popupKey && adConfig[popupKey]) {
    const cfg = adConfig[popupKey]
    if (cfg.start_time) {
      startTime = cfg.start_time
    }
    if (cfg.end_time) {
      endTime = cfg.end_time
    }
  }

  const now = new Date()
  // 没有配置或时间不完整，视为不过期（不关闭弹窗）
  if (!startTime || !endTime) {
    return false
  }
  // 在配置的关闭时间范围内，返回 true 表示需要关闭弹窗广告
  return now >= formatDate(startTime) && now <= formatDate(endTime)
}

/**
 * 判断功能是否在配置的关闭时间段内
 * @param {Object} rangeConfig { start_time, end_time }
 * @returns {Boolean} true=当前在关闭期内（功能应关闭），false=不在关闭期或配置无效（功能可开启）
 */
export const judgeFeatureClosedByRange = (rangeConfig) => {
  if (!rangeConfig) return false
  const startTime = rangeConfig.start_time
  const endTime = rangeConfig.end_time
  if (!startTime || !endTime) return false
  const now = new Date()
  return now >= formatDate(startTime) && now <= formatDate(endTime)
}

// 转化指定日期字符串 为 中国标准时间 兼容方式  防止直接new Date（）意外
export const formatDate = function (dateStr) {
  if (!dateStr) {
    return ''
  }

  if (/^\d{2,4}(-|\/)\d{1,2}(-|\/)\d{1,2}/.test(dateStr)) {
    let gmtTime
    if (/^\d{2,4}-\d{1,2}-\d{1,2}/.test(dateStr)) {
      gmtTime = /\.\d+Z$/.test(dateStr)
      dateStr = dateStr.replace(/-/g, '/').replace(/T/, ' ').replace(/\.\d+Z$/, '').replace(/\.\d+\+/, '+')
        .replace(/\+\d{2}:\d{2}$/, '')
    }

    const date = new Date(dateStr)
    if (gmtTime && date) {
      date.setMinutes(date.getMinutes() - new Date().getTimezoneOffset())
    }
    return date
  } else {
    return ''
  }
}


export const parkTimeformat = (str) => {
  if (!str) return ''
  const timeParts = str.split(':')
  const hours = parseInt(timeParts[0], 10)
  const minutes = parseInt(timeParts[1], 10)
  const seconds = parseInt(timeParts[2], 10)

  return `${hours}时${minutes}分${seconds}秒`
}

/**
 * 计算停车时间
 *
 * @param startTime 停车开始时间（字符串格式，例如："2023-10-01T10:00:00"）
 * @param endTime 停车结束时间（字符串格式，例如："2023-10-01T12:30:00"）
 * @returns 返回停车时间的格式化字符串，格式为 "X时X分X秒"
 */
export const countParkTime = (startTime, endTime) => {
  // 将时间字符串转换为 Date 对象
  const start = new Date(startTime)
  const end = new Date(endTime)

  // 计算两个时间的差值（毫秒）
  const diffInMs = end - start

  // 计算小时、分钟、秒
  const hours = Math.floor(diffInMs / (1000 * 60 * 60)) // 小时
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60)) // 分钟
  const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000) // 秒

  // 返回格式化后的时间差
  return `${hours}时${minutes}分${seconds}秒`
}

/**
 * 支付页展示用停车时长：小时为 0 时不显示「0时」，仅保留分秒
 * @param {string} str 如 "0时51分24秒"
 * @returns {string}
 */
export const formatParkDurationDisplay = (str) => {
  if (!str) return '-'
  let result = str
  if (/^0时/.test(result)) {
    result = result.replace(/^0时/, '')
  }
  if (/^0分/.test(result)) {
    result = result.replace(/^0分/, '')
  }
  return result || '-'
}

/**
 * 解析订单备注（后端字段名不统一）
 * @param {Object} data localInfo / MQTT 消息体
 * @returns {string}
 */
export const resolvePayOrderComment = (data) => {
  if (!data || typeof data !== 'object') return ''
  const keys = ['comment', 'state_ab_comment', 'cancel_comment']
  for (let i = 0; i < keys.length; i++) {
    const val = data[keys[i]]
    if (val != null && String(val).trim() !== '') {
      return String(val).trim()
    }
  }
  return ''
}

export const isTimeGreaterThanZero = (timeString) => {
  if (!timeString) return false
  const parts = timeString.split(':')
  const hours = parseInt(parts[0], 10)
  const minutes = parseInt(parts[1], 10)
  const seconds = parseInt(parts[2], 10)

  const totalSeconds = (hours * 3600) + (minutes * 60) + seconds
  return totalSeconds > 0
}

export const timeStringToSeconds = (timeString) => {
  const parts = timeString.split(':')

  const hours = parseInt(parts[0], 10)
  const minutes = parseInt(parts[1], 10)
  const seconds = parseInt(parts[2], 10)

  const totalSeconds = (hours * 3600) + (minutes * 60) + seconds

  return totalSeconds
}

// 对象一级的成员字典序排序拼接，二级成员做 JSON.stringify
export const objSortJoin = (obj, connection_symbol = '&') => {
  let str = ''
  if (obj && typeof obj === 'object') {
    const newKey = Object.keys(obj).sort()
    for (let i = 0; i < newKey.length; i++) {
      const key = newKey[i]
      const value = obj[key]
      if (value == undefined) {
        continue
      }
      str += `${connection_symbol}${key}=${typeof obj[key] === 'object' ? JSON.stringify(value) : value}`
    }
    if (str.length) {
      str = str.substring(connection_symbol.length)
    }
  }
  return str
}
// 获取查询的地址
export const getIndexUrl = () => {
  return getUrlObjBase(window.location) + '/index'
}
export const getUrlObjBase = (urlObj) => {
  let url = urlObj.protocol + '//' +
    (urlObj.hostname || urlObj.host)
  if (urlObj.port) {
    url += ':' + urlObj.port
  }
  url += urlObj.pathname
  if (window.location.hash && window.location.hash.indexOf('#') === 0) {
    url += '#'
  }
  return url
}
// 获取发券后有效期格式化
export const getUsefulTime = (key) => {
  const list = constant.expireLen
  let name = ''
  list.forEach((x) => {
    if (Number(key) === x.value) {
      name = x.label
    }
  })
  return name
}



export const formatDateNew = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const getNextDayStart = (dateString) => {
  const date = new Date(dateString)
  date.setDate(date.getDate() + 1)
  date.setHours(0, 0, 0, 0)
  return formatDateNew(date)
}

export const getChargeStartTimeNew = (str) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (!str || new Date(str).getFullYear() >= 2999) {
    return formatDateNew(today)
  }
  const inputDate = new Date(str)
  if (isNaN(inputDate.getTime()) || inputDate < today) {
    return formatDateNew(today)
  }
  return getNextDayStart(str)
}

export const getPayType = (str) => {
  const list = constant.payTypeOptions
  let name = ''
  list.find((x) => {
    if (x.value === str) {
      name = x.label
    }
  })
  return name
}

// 计算指定时间差 得出停车时长(x小时x分钟x秒) "2024-08-28T08:10:50.000Z"  "2024-08-28T08:11:06.000Z"
export const countTimeStartEnd = (startTime, endTime) => {
  if (!startTime || !endTime) return ''
  const start = new Date(startTime)
  const end = new Date(endTime)

  let diff = Math.abs(end - start)

  const hours = Math.floor(diff / (1000 * 60 * 60))
  diff -= hours * (1000 * 60 * 60)

  const minutes = Math.floor(diff / (1000 * 60))
  diff -= minutes * (1000 * 60)

  const seconds = Math.floor(diff / 1000)

  return `${hours}小时${minutes}分钟${seconds}秒`
}
// 根据指定日期获取对应月份的结束日期  "2024-08-28T08:10:50.000Z"
export const countRentTimeShow = (dateStr, monthNum) => {
  const date = new Date(dateStr)

  const originalDay = date.getDate()

  date.setMonth(date.getMonth() + monthNum)

  if (date.getDate() < originalDay) {
    date.setDate(0)
  } else {
    date.setDate(originalDay)
  }

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
export const getNextDay = (dateStr) => {
  const date = new Date(dateStr)

  date.setDate(date.getDate() + 1)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const getDateBeforeMonths = (months) => {
  // 获取当前日期
  const currentDate = new Date()
  // 计算目标日期（当前日期减去指定月份数）
  currentDate.setMonth(currentDate.getMonth() - months)
  // 格式化日期为字符串（YYYY-MM-DD）
  const year = currentDate.getFullYear()
  const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 月份从0开始计数，+1，并补0
  const day = String(currentDate.getDate()).padStart(2, '0') // 补0
  // 返回格式化的日期字符串
  return `${year}-${month}-${day} 00:00:00`
}

// 判断时间范围 最大一个月 ，开始日期和结束日期范围不能超过一个月
export const isTimeRangeValid = (startTimeStr, endTimeStr) => {
  const startTime = new Date(startTimeStr)
  const endTime = new Date(endTimeStr)
  if (isNaN(startTime) || isNaN(endTime)) {
    console.error('Invalid date format')
    return false
  }
  const startCopy = new Date(startTime)
  startCopy.setMonth(startCopy.getMonth() + 1)
  startCopy.setDate(startCopy.getDate() - 1)
  return endTime <= startCopy
}

export const getDateOneMonthBeforeToday = () => {
  const date = new Date()
  if (isNaN(date)) {
    console.error('Invalid date format')
    return null
  }
  const newDate = new Date(date)
  newDate.setMonth(newDate.getMonth() - 1)
  const lastDayOfLastMonth = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0).getDate()
  let targetDay = date.getDate() + 1
  if (targetDay > lastDayOfLastMonth) {
    targetDay = lastDayOfLastMonth
  }
  newDate.setDate(targetDay)
  const formattedDate = newDate.toISOString().slice(0, 10) // 'YYYY-MM-DD' 格式
  return formattedDate
}

// 判断指定日期是否等于当天日期 ：年月日
export const countDateIsToday = (str) => {
  const date = new Date(str)
  const today = new Date()

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  )
}
/**
 * 检查两个数组是否完全相同
 * @param {Array} arr1 - 第一个数组
 * @param {Array} arr2 - 第二个数组
 * @returns {boolean} - 如果数组相同则返回 true，否则返回 false
 */
export const areArraysIdentical = (arr1, arr2) => {
  if (!arr1 && !arr2) return true
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
  if (arr1.length !== arr2.length) return false
  return arr1.slice().sort().toString() === arr2.slice().sort().toString()
}

/**
 * 合并路由 query 与 session 缓存，避免微信授权回流时仅有 code 覆盖完整订单参数
 */
export const resolveSaveRouteQueryData = (routeQuery, storageKey) => {
  let savedData = {}
  const stored = sessionStorage.getItem(storageKey)
  if (stored) {
    try {
      savedData = JSON.parse(stored)
    } catch (e) {
      savedData = {}
    }
  }

  if (!routeQuery || routeQuery.plate_number === undefined) {
    return Object.keys(savedData).length > 0 ? savedData : {}
  }

  const isOAuthReturn = !!(routeQuery.code || routeQuery.auth_code)
  const hasFullData = routeQuery.localInfo !== undefined

  if (hasFullData) {
    sessionStorage.setItem(storageKey, JSON.stringify(routeQuery))
    return routeQuery
  }

  if (isOAuthReturn && savedData.localInfo) {
    const merged = { ...savedData }
    if (routeQuery.code) merged.code = routeQuery.code
    if (routeQuery.auth_code) merged.auth_code = routeQuery.auth_code
    sessionStorage.setItem(storageKey, JSON.stringify(merged))
    return merged
  }

  if (savedData.localInfo) {
    return savedData
  }

  sessionStorage.setItem(storageKey, JSON.stringify(routeQuery))
  return routeQuery
}

/**
 * 从 Vuex 或路由缓存中解析欠费订单信息
 */
export const parseEscapeInfo = (escapeInfo, escapeInfoRaw) => {
  if (escapeInfo) return escapeInfo
  if (!escapeInfoRaw) return null
  try {
    return typeof escapeInfoRaw === 'string' ? JSON.parse(escapeInfoRaw) : escapeInfoRaw
  } catch (e) {
    return null
  }
}
